import React from 'react';
import { Icon } from '@gerdau/hefesto';
import { Stepper, Chips } from '@gerdau/hefesto-mais-web';
import { ProductContainer } from './styles';
import { ILoyaltyProductList } from '../../../../../store/ducks/loyalty/types';

interface ProductBlockProps {
  productList: ILoyaltyProductList[];
  deleteProduct: (idx: number) => void;
  updateQty: (idx: number, qty: number) => void;
  updateQtyType: (idx: number, qty_type: string) => void;
}

const ProductBlock: React.FC<ProductBlockProps> = ({
  productList,
  deleteProduct,
  updateQty,
  updateQtyType
}) => {
  const chipParms = [
    {
      id: 'kg',
      label: 'KG'
    },
    {
      id: 'tn',
      label: 'Ton'
    }
  ];

  return (
    <ProductContainer>
      {productList.map((item, idx) => {
        return (
          <div className="product-line" key={`product-line-${idx}`}>
            <div className="name-and-chips-container">
              <span className="product-description">
                {item.product.description}
              </span>
              <Chips
                chips={chipParms}
                selectedChipIds={[item.qty_type]}
                type="choice"
                handleSelect={(id) => {
                  updateQtyType(idx, id.toString());
                }}
              />
            </div>
            <div>
              <Stepper
                helperTextTooltipPlacement="bottomLeft"
                label="Quantidade"
                name="Stepper"
                onChange={(e) => updateQty(idx, Number(e.target.value))}
                value={item.qty}
              />
            </div>
            <div className="delete" onClick={() => deleteProduct(idx)}>
              <span>Excluir</span>
              <Icon option="Trash" variant="primary" size="sm" />
            </div>
          </div>
        );
      })}
    </ProductContainer>
  );
};

export default ProductBlock;
